import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  size?: 'normal' | 'large';
}

export default function ArticleCard({ article, size = 'normal' }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className={`group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
        size === 'large' ? 'lg:grid lg:grid-cols-5' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'lg:col-span-2' : ''}`}>
        <img
          src={article.coverImage}
          alt={article.title}
          className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
            size === 'large' ? 'h-48 lg:h-full' : 'h-48'
          }`}
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
            {article.category === 'profile' ? '个人资料' :
             article.category === 'photobooks' ? '写真集' :
             article.category === 'film-tv' ? '影视作品' :
             article.category === 'news' ? '新闻动态' : '音乐作品'}
          </span>
        </div>
      </div>
      <div className={`p-4 md:p-5 ${size === 'large' ? 'lg:col-span-3' : ''}`}>
        <h3 className={`font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 font-[family-name:var(--font-heading)] ${
          size === 'large' ? 'text-lg md:text-xl' : 'text-base'
        }`}>
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
          <span className="flex items-center gap-1 text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}